// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Int
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.model.savingsaccount.BlockUnblockResponseEntity
import org.mifospay.core.model.savingsaccount.CreateNewSavingEntity
import org.mifospay.core.model.savingsaccount.SavingAccountTemplate
import org.mifospay.core.model.savingsaccount.SavingsWithAssociationsEntity
import org.mifospay.core.model.savingsaccount.TransactionsEntity
import org.mifospay.core.model.savingsaccount.UpdateSavingAccountEntity
import org.mifospay.core.network.model.entity.Page

@OptIn(InternalKtorfitApi::class)
public class _SavingsAccountsServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : SavingsAccountsService {
  override fun getSavingsWithAssociations(accountId: Long, associationType: String): Flow<SavingsWithAssociationsEntity> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "savingsaccounts/${"$accountId".encodeURLPath()}")
        associationType?.let{ parameter("associations", "$it") }
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<SavingsWithAssociationsEntity>>(),)!! 
  }

  override suspend fun getSavingsAccounts(limit: Int): Flow<Page<SavingsWithAssociationsEntity>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "savingsaccounts")
        limit?.let{ parameter("limit", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Page<SavingsWithAssociationsEntity>>>(),)!! 
  }

  override suspend fun createSavingsAccount(savingAccount: CreateNewSavingEntity) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "savingsaccounts")
        }
        setBody(savingAccount) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun updateSavingsAccount(accountId: Long, savingAccount: UpdateSavingAccountEntity) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "savingsaccounts/${"$accountId".encodeURLPath()}")
        }
        setBody(savingAccount) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun blockUnblockAccount(accountId: Long, command: String?): BlockUnblockResponseEntity {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "savingsaccounts/${"$accountId".encodeURLPath()}")
        command?.let{ parameter("command", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<BlockUnblockResponseEntity>(),)!! 
  }

  override suspend fun getSavingAccountTransaction(accountId: Long, transactionId: Long): Flow<TransactionsEntity> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "savingsaccounts/${"$accountId".encodeURLPath()}/transactions/${"$transactionId".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<TransactionsEntity>>(),)!! 
  }

  override suspend fun payViaMobile(accountId: Long): Flow<TransactionsEntity> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "savingsaccounts/${"$accountId".encodeURLPath()}/transactions?command=deposit")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<TransactionsEntity>>(),)!! 
  }

  override fun getSavingAccountTemplate(clientId: Long): Flow<SavingAccountTemplate> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "savingsaccounts/template")
        clientId?.let{ parameter("clientId", "$it") }
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<SavingAccountTemplate>>(),)!! 
  }
}

public class _SavingsAccountsServiceProvider : ClassProvider<SavingsAccountsService> {
  override fun create(_ktorfit: Ktorfit): SavingsAccountsService = _SavingsAccountsServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createSavingsAccountsService(): SavingsAccountsService = _SavingsAccountsServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
